import ReactOnRails from "react-on-rails";

import Navigation from "../bundles/commons/Navigation";
import Dashboard from "../bundles/Dashboard";
import PersonalDashboard from "../bundles/Dashboard/Personal";
import Insights from "../bundles/Insights";
import InsightsError from "../bundles/Insights/Error";
import Notebook from "../bundles/Notebook";
import NotebookNew from "../bundles/Notebook/New";
import GeniusWriter from "../bundles/GeniusWriter";
import PdpShow from "../bundles/Pdp/Show";
import PdpNew from "../bundles/Pdp/New";
import PdpEdit from "../bundles/Pdp/Edit";
import PdpAll from "../bundles/Pdp/All";
import PdpSummary from "../bundles/Pdp/Summary";
import PdpError from "../bundles/Pdp/Error";
import DataLab from "../bundles/DataLab";
import Chat from "../bundles/Chat";
import TeamsIndex from "../bundles/Team/Index";
import TeamInit from "../bundles/Team/Init";
import UsersIndex from "../bundles/Users/Index";
import RegistrationsNew from "../bundles/Devise/Registrations/New";
import CompanyNew from "../bundles/Company/New";
import OnboardingNew from "../bundles/Onboarding/New";
import TeamStageNew from "../bundles/TeamStage/New";
import IntegrationsNew from "../bundles/Integrations/New";
import Confirmation from "../bundles/SurveyKpi/Confirmation";
import AllSet from "../bundles/Responses/AllSet";
import Plans from "../bundles/Plans";
import PlansProcessing from "../bundles/Plans/Processing";
import PlansNewUser from "../bundles/Plans/NewUser";
import PlansWebsite from "../bundles/Plans/Website";
import TrainingCourses from "../bundles/TrainingCourses";
import PersonalSettings from "../bundles/Settings/Personal";
import LanguageSettings from "../bundles/Settings/Language";
import DateTimeSettings from "../bundles/Settings/DateTime";
import ResumeSettings from "../bundles/Settings/Resume";
import IntegrationsSettings from "../bundles/Settings/Integrations";
import ModalContainer from "../bundles/modals/ModalContainer";
import LocaleSwitch from "../bundles/commons/LocaleSwitch";

ReactOnRails.register({
  Navigation,
  Dashboard,
  PersonalDashboard,
  Insights,
  InsightsError,
  Notebook,
  NotebookNew,
  GeniusWriter,
  PdpShow,
  PdpNew,
  PdpEdit,
  PdpAll,
  PdpSummary,
  PdpError,
  DataLab,
  TeamsIndex,
  TeamInit,
  UsersIndex,
  RegistrationsNew,
  CompanyNew,
  OnboardingNew,
  TeamStageNew,
  IntegrationsNew,
  Confirmation,
  AllSet,
  Chat,
  Plans,
  PlansProcessing,
  PlansNewUser,
  PlansWebsite,
  TrainingCourses,
  PersonalSettings,
  LanguageSettings,
  DateTimeSettings,
  ResumeSettings,
  IntegrationsSettings,
  ModalContainer,
  LocaleSwitch
});